var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      attrs: {
        "close-on-content-click": false,
        "min-width": "312",
        "nudge-left": "50%",
        top: "",
        "offset-y": "",
        transition: "slide-y-transition",
        "content-class": "v-application",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "span",
                _vm._g(
                  _vm._b(
                    { class: { "ml-3": _vm.isPublicationItem } },
                    "span",
                    attrs,
                    false
                  ),
                  on
                ),
                [
                  _c("v-timeline-item", {
                    class: [
                      `${_vm.getChunkStatusColor}-shadow`,
                      `pb-0`,
                      { "numeric-chunk": !_vm.isPublicationItem },
                    ],
                    attrs: {
                      icon: !_vm.isPublicationItem
                        ? `mdi-numeric-${_vm.index}`
                        : "mdi-alpha-p",
                      color: _vm.getChunkStatusColor,
                      small: "",
                      "fill-dot": "",
                    },
                  }),
                ],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.isOpen,
        callback: function ($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen",
      },
    },
    [
      _vm._v(" "),
      !_vm.isPublicationItem
        ? _c(
            "v-card",
            { attrs: { loading: _vm.isLoading } },
            [
              _c(
                "v-card-title",
                { staticClass: "justify-space-between" },
                [
                  _c(
                    "div",
                    [
                      _c("span", { staticClass: "h3" }, [
                        _vm._v("Chunk " + _vm._s(_vm.index) + " - "),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-2" }, [
                        _vm._v(_vm._s(_vm.getChunkStatusName)),
                      ]),
                      _vm._v(" "),
                      _vm.status === "skipped_empty"
                        ? _c(
                            "v-icon",
                            { staticClass: "ml-2", attrs: { color: "error" } },
                            [_vm._v("mdi-debug-step-over")]
                          )
                        : _vm.status === "sent"
                        ? _c(
                            "v-icon",
                            {
                              staticClass: "ml-2",
                              attrs: { color: "success" },
                            },
                            [_vm._v("mdi-check-circle-outline")]
                          )
                        : _vm.status === "scheduled"
                        ? _c(
                            "v-icon",
                            {
                              staticClass: "ml-2",
                              attrs: { color: "warning" },
                            },
                            [_vm._v("mdi-calendar-clock")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.status === "scheduled"
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "ml-3",
                          attrs: { color: "success", small: "" },
                          on: { click: _vm.sendNow },
                        },
                        [
                          _vm._v("\n                Senden\n                "),
                          _c(
                            "v-icon",
                            { staticClass: "ml-2", attrs: { size: "18" } },
                            [_vm._v("mdi-check-circle-outline")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("p", { staticClass: "h5" }, [
                    _vm._v(
                      "\n                Zeit: " +
                        _vm._s(_vm.formatDate) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: _vm.status === "scheduled" ? "auto" : "12",
                          },
                        },
                        [
                          _vm.pharmacists.length
                            ? _c(
                                "v-list",
                                {
                                  staticClass: "overflow-y-auto",
                                  attrs: { "max-height": "330" },
                                },
                                [
                                  _c("v-subheader", [_vm._v("Freiberufler")]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.pharmacists,
                                    function (pharmacist, idx) {
                                      return [
                                        _c(
                                          "v-list-item",
                                          { attrs: { dense: "" } },
                                          [
                                            _c(
                                              "v-list-item-content",
                                              { staticClass: "p-0" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href: `/pharmacists/${pharmacist.id}`,
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          pharmacist.name
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        idx < _vm.pharmacists.length - 1
                                          ? _c("v-divider")
                                          : _vm._e(),
                                      ]
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.status === "scheduled"
                        ? _c(
                            "v-col",
                            { attrs: { cols: "auto" } },
                            [
                              _c("vc-date-picker", {
                                attrs: {
                                  "minute-increment": 15,
                                  mode: "datetime",
                                  locale: "de",
                                  is24hr: "",
                                },
                                model: {
                                  value: _vm.scheduledTime,
                                  callback: function ($$v) {
                                    _vm.scheduledTime = $$v
                                  },
                                  expression: "scheduledTime",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mt-2",
                                  attrs: {
                                    disabled: !_vm.scheduledTime,
                                    color: "primary",
                                    small: "",
                                    depressed: "",
                                    block: "",
                                  },
                                  on: { click: _vm.schedule },
                                },
                                [
                                  _vm._v(
                                    "\n                        Chunkzeit ändern\n                    "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
            ],
            1
          )
        : _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c("span", { staticClass: "h3" }, [_vm._v("Publikation - ")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "ml-2" }, [
                    _vm._v(_vm._s(_vm.getChunkStatusName)),
                  ]),
                  _vm._v(" "),
                  _vm.status === "sent"
                    ? _c(
                        "v-icon",
                        { staticClass: "ml-2", attrs: { color: "success" } },
                        [_vm._v("mdi-check-circle-outline")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _c("p", { staticClass: "h5" }, [
                  _vm._v(
                    "\n                Zeit: " +
                      _vm._s(_vm.formatDate) +
                      "\n            "
                  ),
                ]),
              ]),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }